import { EventEmiterService } from './../../shared/services/quotation/event-emiter.service';
import { ChangeDetectorRef, Component, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralService } from '../../shared/services/general.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { TableGeneralSimpleComponent } from '../../shared/components-generals/table-general-simple/table-general-simple.component';
import { ExpiredPortfolioService } from '../../shared/services/expired-portfolio/expired-portfolio.service';
import { MatSortModule, MatSort } from '@angular/material/sort';
import {
  ExpiredPortfolioClient,
  ExpiredPortfolioPaged,
} from '../../shared/models/expired-portfolio/expired-portfolio.model';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { PagedFilter } from '../../shared/models/components-general/general-filter.model';
import { RouteService } from '../../shared/services/route.service';
import { TabRouter } from '../../shared/models/components-general/router.model';
import { TabMenuSimple } from '../../shared/components-generals/tab-menu-simple/tab-menu-simple';
@Component({
  selector: 'app-expired-portfolio.component',
  imports: [
    TranslateModule,
    InputGeneral,
    TableGeneralSimpleComponent,
    MatPaginator,
    MatSortModule,
    LoadGeneralComponent,
    TabMenuSimple,
  ],
  templateUrl: './expired-portfolio.component.html',
  styleUrls: ['./expired-portfolio.component.css'],
})
export class ExpiredPortfolioComponent implements OnDestroy {
  public subscribeArray: Subscription[] = [];
  public pageIndex = 1;
  public loadService = false;
  public indexSelected = 0;
  public dataSource = new MatTableDataSource<ExpiredPortfolioClient>([]);
  public headers: { value: string; description: string }[] = [];
  public subHeaders: { value: string; description: string }[] = [];
  public filter: FormGroup;
  public listExpiredPortfolio: ExpiredPortfolioPaged | null = null;
  public loadSubTabla = false;
  public analyticsRouter: TabRouter[] = [];

  @ViewChild('MatPaginatorExpiredPortfolio') MatPaginatorExpiredPortfolio!: MatPaginator;
  @ViewChild('MatSortExpiredPortfolio') MatSortExpiredPortfolio!: MatSort;

  constructor(
    public dialog: MatDialog,
    private expiredPortfolioService: ExpiredPortfolioService,
    private generalService: GeneralService,
    private cdr: ChangeDetectorRef,
    private RouteService: RouteService,
  ) {
    this.analyticsRouter = this.RouteService.analyticsRouter;
    this.filter = new FormGroup({
      pageSize: new FormControl('10'),
      sortActive: new FormControl(0),
      sortDirection: new FormControl(0),
      filter: new FormControl(null),
    });
    const sub = this.generalService.subscribeFormSimple(this.filter).subscribe((ress) => {
      this.pageIndex = 1;
      this.getExpiredPortfolio({
        page: this.pageIndex.toString(),
        pageSize: ress.pageSize,
        sortActive: ress.sortActive,
        sortDirection: ress.sortDirection,
        filter: ress.filter,
      });
    });
    this.subscribeArray.push(sub);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  public unsubscribeAll(): void {
    this.subscribeArray.forEach((sub) => sub.unsubscribe());
    this.subscribeArray = [];
  }

  private getExpiredPortfolio(body: PagedFilter): void {
    this.loadService = true;
    const sub = this.expiredPortfolioService.getExpiredPortfolio(body).subscribe((response) => {
      this.listExpiredPortfolio = null;

      if (response) {
        this.listExpiredPortfolio = response;
        this.dataSource = new MatTableDataSource<ExpiredPortfolioClient>(
          this.listExpiredPortfolio.expiredPortfolioClient,
        );
        this.headers = [
          { value: 'id', description: 'Id' },
          { value: 'client', description: 'Cliente' },
          { value: 'totalExpired', description: '$ Atrasado' },
        ];
        this.subHeaders = [
          { value: 'id', description: 'Cotización' },
          { value: 'description', description: 'Descripción' },
          { value: 'expirationDate', description: 'Fecha Exigible' },
          { value: 'amountOverdue', description: '$ Monto' },
        ];
      }
      this.loadService = false;
    });
    this.subscribeArray.push(sub);
  }

  public onPageChange(event: number): void {
    this.pageIndex = event + 1;
    this.getExpiredPortfolio({
      page: this.pageIndex.toString(),
      pageSize: this.filter.value.pageSize || '10',
      sortActive: this.filter.value.sortActive || 0,
      sortDirection: this.filter.value.sortDirection || 0,
      filter: this.filter.value.filter || null,
    });
  }

  public onActionButtonClick(row: any): void {
    if (!row || !row.id) return;

    if (row.isExpanded) {
      row.isExpanded = false;
      this.cdr.detectChanges();
      return;
    }

    if (row.detailData) {
      row.isExpanded = true;
      this.cdr.detectChanges();
      return;
    }

    row.isSubLoading = true;
    row.isExpanded = true;
    this.cdr.detectChanges();

    const sub = this.expiredPortfolioService.GetDetailExpiredPortfolioClient(row.id).subscribe({
      next: (detail: any[]) => {
        row.detailData = detail;
        row.isSubLoading = false;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al recuperar el desglose del cliente:', err);
        row.isSubLoading = false;
        row.isExpanded = false;
        row.detailData = [];
        this.cdr.detectChanges();
      },
    });
    this.subscribeArray.push(sub);
  }

  public changeSelected(url: string, index: number): void {
    this.RouteService.changeSelected(url, index);
  }
}
